import type { AxiosError } from 'axios'
import type { SendCalculationEmailRequest, SendContractEmailRequest, SendContractEmailResponse } from 'BrokerTsLib/src/dtos'
import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { useMutation, useQuery } from '@tanstack/react-query'

import { Apis } from '@/appSettings'

import { useUrl } from '.'

export interface GetCalculationEmailResponse {
  subject: string,
  logoUrl: string,
  email?: string,
  header: string,
  footer: string,
  signature: string,
  disclaimer: string
}

export interface GetContractEmailResponse {
  subject: string,
  logoUrl: string,
  email: string,
  header: string,
  recap: string,
  acceptation: string,
  documents: string,
  signature: string,
  disclaimer: string
}
export function useGetCalculationEmail<T = GetCalculationEmailResponse>(paramsId: string, insurerOfferIds: number[], enabled?: boolean) {
  const url = useUrl(Apis.mailing)

  return useQuery({
    queryKey: ['GetCalculationEmail', paramsId, insurerOfferIds],
    queryFn: () =>
      apiClient.get<T>(`${url}/GetCalculationEmail`, { params: { paramsId, insurerOfferIds: insurerOfferIds.join(',') } }).then(res => res.data),
    enabled: !!paramsId && insurerOfferIds.length > 0 && enabled,
  })
}

export const useSendCalculationEmail = () => {
  const url = useUrl(Apis.mailing)

  return useMutation({ mutationFn: (value: SendCalculationEmailRequest) =>
    apiClient.post(`${url}/SendCalculationEmail`, value) })
}

export function useGetContractEmail<T = GetContractEmailResponse>(paramsId?: string, insuranceId?: number, enabled?: boolean) {
  const url = useUrl(Apis.mailing)

  return useQuery<T, AxiosError>({
    queryKey: ['GetContractEmail', paramsId, insuranceId],
    queryFn: () =>
      apiClient.get<T>(`${url}/GetContractEmail`, { params: { paramsId, insuranceId } }).then(res => res.data),
    enabled: !!paramsId && enabled,
  })
}

export const useSendContractEmail = () => {
  const url = useUrl(Apis.mailing)

  return useMutation({
    mutationFn: (value: SendContractEmailRequest) =>
      apiClient.post<SendContractEmailResponse>(`${url}/SendContractEmail`, value)
  })
}